import { eventSearchService } from '@mediabank/client';

const eventsServiceWrapper = {};

for (const [methodName, method] of Object.entries(eventSearchService)) {
    eventsServiceWrapper[methodName] = (...args) =>
        method(...args).catch(error => {
            console.error(`mediabank-next-transition error: ${methodName} service.`, error);

            if (error?.response?.status === 401) {
                window.location.href = '/logout';
            }

            return error.response;
        });
}

export default { ...eventsServiceWrapper };
